import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateGREmailsInput,
    GREmails,
    UpdateGREmailsInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class GrEmailsService {
    private amplifyClient = generateClient();
    constructor() {}

    async listGREmails(): Promise<GREmails[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listGREmails
                })
            ).data.listGREmails.items;
            if (data) return data as GREmails[];
        } catch (error) {
            console.error('Error finding GREmails:', error);
            return null;
        }
    }
    async gREEmailsByCompanyId(companyId: string): Promise<GREmails[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.GREmailsByCompanyId,
                    variables: {
                        companyId
                    }
                })
            ).data.GREmailsByCompanyId.items;
            if (data) return data as GREmails[];
        } catch (error) {
            console.error('Error finding GREmails:', error);
            return null;
        }
    }

    async createGREmail(input: CreateGREmailsInput): Promise<GREmails> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createGREmails,
                    variables: {
                        input
                    }
                })
            ).data.createGREmails;
            if (data) return data as GREmails;
        } catch (error) {
            console.error('Error creating GREmails:', error);
            return null;
        }
    }

    async updateGREmails(input: UpdateGREmailsInput): Promise<GREmails> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updateGREmails,
                    variables: {
                        input
                    }
                })
            ).data.updateGREmails;
            if (data) return data as GREmails;
        } catch (error) {
            console.error('Error updated GREmails:', error);
            return null;
        }
    }
}
